
import { NONE } from './types';

export default NONE;
